import { createQuery } from 'react-query-kit';
import { ErrorResponse, privateApi } from 'api';
import { AxiosError } from 'axios';
import { Charge } from './GetCharge';

export type GetChargesParams = {
    studentId: string;
}

export type GetChargesResult = Charge[] | null;

async function getCharges(params: GetChargesParams): Promise<GetChargesResult | null> {
    // create new URL object for the API endpoint
    const requestUrl = new URL(`${import.meta.env.VITE_API_BASE_URL}/finance/charges`);

    // create new URLSearchParams object to store query parameters
    const searchParams = new URLSearchParams();

    // add each parameter to searchParams if the value is not null or undefined
    Object.entries(params).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
            searchParams.set(key, String(value));
        }
    });

    // add the query string to the requestUrl
    requestUrl.search = searchParams.toString();

    // make api call
    const result = await privateApi.get(requestUrl.toString());

    // return the data object
    return result.data as GetChargesResult;
}

const useGetCharges = createQuery<GetChargesResult, GetChargesParams, AxiosError<ErrorResponse>>({
    queryKey: ['charges'],
    fetcher: (variables) => getCharges(variables),
})

export { useGetCharges };

